import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { loginGoogle } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/login"); return; }
    (async () => {
      try {
        await loginGoogle(sid);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard");
      } catch {
        setError("Google sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    })();
  }, [loginGoogle, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-sidebar text-white">
      <img src="/icons/icon-192.png" alt="Hunter" className="h-16 w-16 rounded-sm" />
      {error ? (
        <p className="text-red-400">{error}</p>
      ) : (
        <div className="flex items-center gap-2 text-white/70">
          <span className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          Signing you in…
        </div>
      )}
    </div>
  );
}
